import Layout from 'layouts/Layout/Layout'
import classNames from 'classnames'
import { Button, Container } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import useDocumentTitle from 'hooks/useDocumentTitle'
import imgHomeCiblerBienAVendre from 'assets/default/png/home_cibler_bien_a_vendre.png'
import imgHomeBiensVendus from 'assets/default/png/home_biens_vendus.png'
import styles from './Home.module.scss'

const Home = (): JSX.Element => {
  const history = useHistory()

  useDocumentTitle('Accueil')

  return (
    <Layout>
      <Container className={styles.pageHome}>
        <div>
          <h2 className={styles.vendre}>Cibler un bien à vendre</h2>
          <div className={classNames(styles.text, styles.vendre)}>
            Vous avez repéré une maison ou un terrain à vendre sur un site
            d’annonces ?
            <br />
            Essayez maintenant de le géolocaliser !
            <br />
            <br />
            Grâce à un moteur de recherche complet, saisissez les
            caractéristiques du bien et repérez-le sur la carte.
            <br />
            <br />
            Vous pensez l’avoir trouvé ? Allez vite toquer à la porte pour
            récupérer le mandat !
          </div>
          <div className={classNames(styles.image, styles.vendre)}>
            <img src={imgHomeCiblerBienAVendre} alt="Cibler biens à vendre" />
          </div>
          <div className={classNames(styles.c_button, styles.vendre)}>
            <Button
              size="lg"
              variant="primary"
              onClick={() => history.push('/biens-a-vendre')}
            >
              Cibler un bien à vendre
            </Button>
          </div>
          <h2 className={styles.vendu}>Etudier votre marché</h2>
          <div className={classNames(styles.text, styles.vendu)}>
            Réalisez votre étude de marché en consultant les biens vendus sur
            votre zone d’activité.
            <br />
            <br />
            Il vous suffit de filtrer selon les critères de recherche votre
            choix, et le tour est joué !
          </div>
          <div className={classNames(styles.image, styles.vendu)}>
            <img src={imgHomeBiensVendus} alt="Localiser biens vendus" />
          </div>
          <div className={classNames(styles.c_button, styles.vendu)}>
            <Button
              size="lg"
              variant="primary"
              onClick={() => history.push('/etudier-votre-marche')}
            >
              Etudier mon marché
            </Button>
          </div>
        </div>
      </Container>
    </Layout>
  )
}

export default Home
